import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function DomainGateway() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const user = await login(email, password, false);
            toast.success("Welcome back!");
            navigate(`/${user.client_slug}`);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0A192F] flex flex-col items-center justify-center p-4 relative overflow-hidden">
            <div className="absolute inset-0 z-0 opacity-20" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1559612589-9df3eaf13f28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxmaW5hbmNpYWwlMjBjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzkwNDg4NjI2fDA&ixlib=rb-4.1.0&q=85')", backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            <div className="absolute inset-0 bg-[#0A192F]/80 z-0 backdrop-blur-sm"></div>
            
            <div className="z-10 bg-white/5 backdrop-blur-xl border border-white/10 p-8 rounded-2xl shadow-2xl max-w-md w-full">
                <div className="w-16 h-16 bg-[#EAB308] rounded-xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-amber-500/20">
                     <span className="font-bold text-2xl text-[#0A192F]">RC</span>
                </div>
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-bold text-white mb-2 font-['Cabinet_Grotesk']">RC Company Portal</h1>
                    <p className="text-slate-300 text-sm">Sign in to your bookkeeping workspace.</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-slate-300 text-sm font-medium mb-1">Email Address</label>
                        <input 
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@company.com"
                            className="w-full bg-white/10 border border-white/20 focus:border-[#EAB308] text-white px-4 py-3 rounded-lg focus:outline-none transition-colors"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-slate-300 text-sm font-medium mb-1">Password</label>
                        <input 
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            className="w-full bg-white/10 border border-white/20 focus:border-[#EAB308] text-white px-4 py-3 rounded-lg focus:outline-none transition-colors"
                            required
                        />
                    </div>
                    <button type="submit" disabled={loading} className="w-full bg-[#EAB308] hover:bg-[#CA8A04] text-[#0A192F] font-bold py-3 rounded-lg transition-all active:scale-95 shadow-md flex justify-center items-center gap-2 mt-4">
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>

                <div className="mt-8 pt-6 border-t border-white/10 text-center">
                    <button onClick={() => navigate('/adminpanel/login')} className="text-xs text-slate-400 hover:text-white transition-colors">
                        Super Admin Access
                    </button>
                </div>
            </div>
        </div>
    )
}
